const lastLetterIs = (value: string, search: string) => (
  value.length > 0 && value.lastIndexOf(search) + 1 === value.length
);

export const getByKey = (key: string, search: string, limit = ':') => {
  const inputs = search.replace(/: */g, ': ').replace(/ +/g, ' ').trim().split(' ');
  const value: string[] = [];
  let next = false;
  for (let i = 0; i < inputs.length; i += 1) {
    const input = inputs[i];
    if (next && input) {
      if (lastLetterIs(input, limit)) {
        break;
      }
      value.push(input);
    }
    if (`${key}${limit}` === input) {
      next = true;
    }
  }
  return value.join(' ');
};

export default function getByKeys<Key extends string>(
  keys: Key[],
  search: string,
  defaultKey?: Key,
): Partial<Record<Key, string>> {
  type Result = Record<typeof keys[number], string>;
  const values = {} as Result;
  keys.forEach((key) => {
    const value = getByKey(key, search);
    if (value) {
      values[key] = value;
    }
  });
  if (defaultKey && Object.keys(values).length === 0) {
    return {
      [defaultKey]: search,
    } as Partial<Record<Key, string>>;
  }
  return values;
}

type KeyValue = string | undefined | null | number | boolean | undefined;
export const toKey = (values: Record<string, KeyValue | KeyValue[]>) => {
  let response = '';
  Object.keys(values).forEach((key) => {
    const value = values[key];
    if (value !== undefined) {
      if (Array.isArray(value)) {
        if (value.length > 0) {
          response += ` ${key}: ${value.join(',')}`;
        }
      } else {
        response += ` ${key}: ${value}`;
      }
    }
  });
  return response;
};
